import { render, staticRenderFns } from "./TaxReturnDigitalPlatform.vue?vue&type=template&id=64476c86&scoped=true"
import script from "./TaxReturnDigitalPlatform.vue?vue&type=script&lang=js"
export * from "./TaxReturnDigitalPlatform.vue?vue&type=script&lang=js"
import style0 from "./TaxReturnDigitalPlatform.vue?vue&type=style&index=0&id=64476c86&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64476c86",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/ovilla/Documents/strappberry/catara-server/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('64476c86')) {
      api.createRecord('64476c86', component.options)
    } else {
      api.reload('64476c86', component.options)
    }
    module.hot.accept("./TaxReturnDigitalPlatform.vue?vue&type=template&id=64476c86&scoped=true", function () {
      api.rerender('64476c86', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/components/TaxReturnDigitalPlatform.vue"
export default component.exports